import { storyblokEditable } from "@storyblok/react"

export default function SbEditable({ content, children, ...props }) {
	return (
		<div 
			{...storyblokEditable(content)} 
			key={content._uid}
			{...props}
		>
			{children}
		</div>
	)
}